<div class="col-md-12 mb-30" [hidden]="Selected_PM_Record_Switcher!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعات سرویس های PM</h5>
     <br/>
     <br/>
     <div class="row">

      <div class="col-md-4">
        <div class="card card-statistics h-100">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-left icon-box bg-info rounded-circle">
                <span class="text-white">
                  <i class="fa  fa-clock-o highlight-icon" aria-hidden="true"></i>
                </span>
              </div>
              <div class="float-right text-right">
                <p class="card-text text-dark">	تعداد سرویس های تاخیر </p>
                <h4>{{unDelay.length}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card card-statistics h-100">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-left icon-box bg-warning rounded-circle">
                <span class="text-white">
                  <i class="fa fa-warning highlight-icon" aria-hidden="true"></i>
                </span>
              </div>
              <div class="float-right text-right">
                <p class="card-text text-dark">	تعداد سرویس های شروع نشده </p>
                <h4>{{unstarted.length}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card card-statistics h-100">
          <div class="card-body">
            <div class="clearfix">
              <div class="float-left icon-box bg-danger rounded-circle">
                <span class="text-white">
                  <i class="fa fa-times-circle-o highlight-icon" aria-hidden="true"></i>
                </span>
              </div>
              <div class="float-right text-right">
                <p class="card-text text-dark"> تعداد تجهیزات فعال بدون سرویس </p>
                <h4>{{unServiceDeviceBehfa.length}}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>

     <div class="row">
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">برنامه</label>
        <input [(ngModel)]="Filter_Title" (keyup)="Change_Filter()" name="Filter_Title" type="text" class="form-control"  placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Description</label>
        <input [(ngModel)]="Filter_Description" (keyup)="Change_Filter()" name="Description" type="text"
          class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Manufacturer</label>
        <input [(ngModel)]="Filter_Manufacturer" (keyup)="Change_Filter()" name="Filter_Manufacturer" type="text"
          class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Model</label>
        <input [(ngModel)]="Filter_Model" (keyup)="Change_Filter()" name="Filter_Model" type="text"
          class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">Code BEHFA</label>
        <input [(ngModel)]="Filter_Code" (keyup)="Change_Filter()" name="Filter_Code" type="text" class="form-control"
          placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_PM()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button *ngIf="!Procssing" (click)="Set_Form_PM_View_Add()" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>برنامه</th>
              <th>تاریخ قبلی</th>
              <th>تاریخ بعدی</th>
              <th>Description</th>
              <th>Manufacturer</th>
              <th>Model</th>
              <th>Code BEHFA</th>
              <th>ایجاد کننده</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_PM
            |filter:Filter_Title:'title'
            |filter2:Filter_Description:'deviceBehfa':'description'
            |filter2:Filter_Manufacturer:'deviceBehfa':'manufacturer'
            |filter2:Filter_Model:'deviceBehfa':'model'
            |filter2:Filter_Code:'deviceBehfa':'codeBEHFA'
            | paginate
                    : {
                        id: 'DataList_PMTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_PM
                        |filter:Filter_Title:'title'
                        |filter2:Filter_Description:'deviceBehfa':'description'
                        |filter2:Filter_Manufacturer:'deviceBehfa':'manufacturer'
                        |filter2:Filter_Model:'deviceBehfa':'model'
                        |filter2:Filter_Code:'deviceBehfa':'codeBEHFA'
                        ).length
                      }
            ">
             <td>{{DataList_PM.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.base_date}}</td>
              <td>{{item.next_date}}</td>
              <td>{{item.deviceBehfa.description}}</td>
              <td>{{item.deviceBehfa.manufacturer}}</td>
              <td>{{item.deviceBehfa.model}}</td>
              <td>{{item.deviceBehfa.codeBEHFA}}</td>
              <td>{{item.username}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> حذف </a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_PMTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<div  class="col-md-12 mb-30" *ngIf="Selected_PM_Record_Switcher=='Form'">
  <app-PMServiceForm
  [inner_PM]="Selected_PM_Record">
  </app-PMServiceForm>

  <button (click)="Set_List_PM_View()" type="button" class="btn btn-warning"><i
    class="fa fa-mail-reply"></i> بازگشت </button>

</div>

<ng-template #template>
  <div class="modal-header">
    <h4  class="modal-title pull-left">تایید حذف دوره سرویس
      '{{Data_Seleted_Delete.deviceBehfa.codeBEHFA}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> حذف اطلاعات <i class="fa fa-remove"></i></button>

    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>
